import { Theme, useMediaQuery } from "@mui/material";
import { CreateButton, Datagrid, DateField, FunctionField, List, Loading, NullableBooleanInput, SearchInput, ShowButton, TextField, TopToolbar, useAuthenticated, useAuthState, useTranslate, WrapperField } from "react-admin";
import LoggingListAside from './LoggingListAside';
import LoggingShow from "./LoggingShow";
import { Pagination } from 'react-admin';

const url = `${process.env.REACT_APP_API_URL || 'https://logs.walk.in'}`;

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]} />;

const LoggingList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    const translate = useTranslate();
const positions:any=[];
    return (
        <List  aside={<LoggingListAside data={positions}/>} actions={<ListActions />} sort={{ field: 'id', order: 'DESC' }} pagination={<PostPagination />}>

            <Datagrid rowClick="expand" expand={<LoggingShow />}>
                <TextField source="id" />
                <TextField source="source" />
                <FunctionField label="Date" render={(record: any) => { 
                    try{
                        const date2 = new Date(parseInt(record.date));
                        return `${date2.toString().split('GMT')[0]}`;
                    } catch (e){
                        return 'error';
                    }
                    } } />
                <TextField source="action" />
                <TextField source="level" />
                <TextField source="corellationId" />
                <TextField source="method" />
                <TextField source="time" />
                <TextField source="ip" />
                <TextField source="message" />
                
                
            </Datagrid>
        </List>
    );

}
const ListActions = ({ isSmall }: any) => (
    <TopToolbar sx={{ minHeight: { sm: 56 } }}>

    
    </TopToolbar>
);

export default LoggingList;